import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import { TdLoadingService, TdDialogService, } from '@covalent/core';
import { MdSelect } from '@angular/material';

import { NotasService, MasterService, LoginService, } from '../../../../services/';

import { Nota } from '../../../../models';

@Component({
  selector: 'qs-notasdetalle',
  styleUrls: ['./notasdetalle.component.scss'],
  templateUrl: './notasdetalle.component.html',
  viewProviders: [NotasService],
})

export class NotasDetalleComponent implements AfterViewInit, OnDestroy {

  private mode: string;
  private title: string;

  private fecha: Date;
  private dniMedico: string;
  private idPaciente: string;

  private nota: Nota;
  private oldNota: Nota;

  constructor(private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _notasService: NotasService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.nota = new Nota();
    this.oldNota = new Nota();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.nota = this._loginService.transient;
      let fecha: string[] = this.nota.fecha.split('/');
      this.fecha = new Date(`${fecha[2]}/${fecha[1]}/${fecha[0]}`);
      this.oldNota = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
      this.fecha = new Date();
    }
  }

  ngAfterViewInit(): void {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.dniMedico = this._loginService.profesional.Dni;
    this._changeDetectorRef.detectChanges();
  }

  save(form: NgForm): void {
    this._loadingService.register();
    if (form.valid) {
      let errorMessage: string = 'Se ha producido un error: ';
      let message: string = 'correctamente.';
      let action: string = 'Ok';
      let duration: number = 3000;
      let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/notas/';
      if (this.mode === 'add') {
        message = 'Nota añadida ' + message;
      } else {
        message = 'Nota actualizada ' + message;
      }
      let fecha: string = this.fecha.getDate() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getFullYear();
      if (this.mode === 'add') {
        // Modo alta de nueva nota
        this._notasService.crearNota(this.dniMedico, fecha, this.nota.comentario, this.idPaciente).subscribe((res: any) => {
          if (res.respuesta) {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje(message, action, duration);
            this._router.navigate([route]);
          } else {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje(errorMessage + '', action, duration);
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje(errorMessage + error, action, duration);
          this._loadingService.resolve();
        });
        this.mode = 'save';
      } else {
        // Modo actualización
        this._notasService.actualizarNota(fecha, this.nota.comentario, this.nota.idPostit).subscribe((res: any) => {
          if (res.respuesta) {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje(message, action, duration);
            this._router.navigate([route]);
          } else {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje(errorMessage + '', action, duration);
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje(errorMessage + error, action, duration);
          this._loadingService.resolve();
        });
      }
    }
  }

  delete(): void {
    let errorMessage: string = 'Se ha producido un error: ';
    let message: string = 'correctamente.';
    let action: string = 'Ok';
    let duration: number = 3000;
    let route: string = '/main/consulta/' + this._loginService.consulta.numeroExpediente + '/notas/';
    this._dialogService.openConfirm({
      message: 'Pulse ACEPTAR para borrar la nota.',
      disableClose: true,
      title: 'Borrar nota',
      cancelButton: 'Cancelar',
      acceptButton: 'Aceptar',
    }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this._loadingService.register();
        this._notasService.borrarNota(this.nota.idPostit).subscribe((res: any) => {
          if (res.respuesta) {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje('Nota borrada ' + message, action, duration);
            this._router.navigate([route]);
          } else {
            this._loadingService.resolve();
            this._loginService.mostrarMensaje(errorMessage + '', action, duration);
          }
        }, (error: Error) => {
          this._loginService.mostrarMensaje(errorMessage + error, action, duration);
          this._loadingService.resolve();
        });
      }
    });
  }

  canDeactivate(): Promise<boolean> | boolean {
    if (this.oldNota.comentario === this.nota.comentario) {
      return true;
    } else {
      if (this.mode !== 'save') {
        return new Promise((resolve: any) => {
          this._dialogService.openConfirm({
            message: 'Si pulsa aceptar, se perderán los datos introducidos.',
            title: '¿Desea abandonar el alta de nota?',
            acceptButton: 'Aceptar',
            cancelButton: 'Cancelar',
          }).afterClosed().subscribe((accept: boolean) => {
            if (accept) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        });
      } else {
        return true;
      }
    }
  }

  ngOnDestroy(): void {
    this._loginService.transient = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/notas/notasdetalle/notasdetalle.component.ts